export const pageMessages= {
    noToken: "No Active User / User Session expired. Please logout and re-login.",
    unknownError: "Something went wrong, please try again.",
    rbacNameRequired: "Please enter group name.",
    rbacDomainsRequired: "Please select atleast one domain.",
    editmenuNoNameChange: "There is no change from the previous Menu name. Please modify to edit.",
    editRbacNoChange: "There is no change from the previous Group name or Grouped Domains. Please modify to edit.",
    invalidQuestion: "Please post a valid Question",
    docUpload: "All Fields are mandatory",
    docEditNochange: "No edit performed on the document.",
    emptyFile: "You are trying to upload an empty document. Please ensure a valid document.",
    fileSize: "Please ensure you have upload valid document and size of document is under 25MB",
    sopMaxLimit: 'You have selected more than allowed number of documents. Max Limit : 4',
    tokenExpired: "Session Expired, Redirecting to login page.",
    notValidMenuName: "Please enter a valid Menu Name.",
    notValidOwnerName: "Please enter a valid Owner Name.",
    fileName:`File name should not contain \\ / : * ? ; " ' < > ^ ~ | .`
}